import styled, { css } from 'styled-components'

const ErrorStyle = css`
  border: 1px solid ${({ theme }) => theme.error};
`

export const TextAreaField = styled.textarea`
  display: block;
  width: 100%;
  padding: .7rem 1rem;
  color: inherit;
  line-height: 1.6;
  font-size: 1.5rem;
  font-family: inherit;
  position: relative;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.border};
  cursor: default;
  resize: none;

  &:focus {
    outline: none;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    border: 1px solid ${({ theme }) => theme.primary};
  }

  &:disabled {
    opacity: .5;
    pointer-events: none;
  }

  ${({ hasError }) => hasError && ErrorStyle}
`



// WEBPACK FOOTER //
// ./src/Components/TextArea/styles.js